/* eslint-disable */
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default {
  init() {
    const mobSubs = document.querySelectorAll('.js-mob-has-sub');
    if (mobSubs) {
      mobSubs.forEach(sub => {
        const container = sub.closest('li');
        sub.addEventListener('click', e => {
          const submenu = container.querySelector('.mobile-menu__submenu');
          e.preventDefault();
          if (container.classList.contains('is-active')) {
            container.classList.remove('is-active');
            submenu.style.maxHeight = null;
          } else {
            container.classList.add('is-active');
            submenu.style.maxHeight = submenu.scrollHeight + 'px';
          }
        });
      });
    }

    const burger = document.querySelector('.burger');
    const drawer = document.querySelector('.drawer');
    const header = document.querySelector('header');
    if (burger && drawer) {
      burger.addEventListener('click', e => {
        e.preventDefault();
        if (
          burger.classList.contains('is-active') &&
          drawer.classList.contains('is-open')
        ) {
          closeAll();
          enableBodyScroll(drawer);
        } else {
          disableBodyScroll(drawer);
          burger.classList.add('is-active');
          drawer.classList.add('is-open');
          header.classList.add('is-open');
        }
      });
    }

    const submenuLinks = document.querySelectorAll(
      '.menu__item--has-submenu > a'
    );
    if (submenuLinks) {
      submenuLinks.forEach(link => {
        link.addEventListener('click', e => {
          if (screen.width <= 1024) {
            e.preventDefault();
          }
        });
      });
    }

    const mobileLinks = drawer.querySelectorAll('a:not(.js-mob-has-sub)');
    if (mobileLinks) {
      mobileLinks.forEach(link => {
        link.addEventListener('click', e => {
          closeAll();
        });
      });
    }

    function closeAll() {
      drawer.classList.remove('is-open');
      burger.classList.remove('is-active');
      header.classList.remove('is-open');
      enableBodyScroll(drawer);
      mobSubs.forEach(sub => {
        const container = sub.closest('li');
        const submenu = container.querySelector('.mobile-menu__submenu');
        container.classList.remove('is-active');
        submenu.style.maxHeight = null;
      });
    }

    var lastScrollTop = 0;
    window.onscroll = function() {
      scrollFunction();
    };
    function scrollFunction() {
      if (
        window.pageYOffset > 250 ||
        document.body.scrollTop > 250 ||
        document.documentElement.scrollTop > 250
      ) {
        header.classList.add('is-shrinked');
      } else {
        header.classList.remove('is-shrinked');
      }

      var st = window.pageYOffset || document.documentElement.scrollTop;
      var documentHg =
        document.documentElement.scrollHeight - window.innerHeight;

      if (st > lastScrollTop) {
        document
          .querySelector('.scroll-to--to-top')
          .classList.remove('is-visible');
      } else {
        if (
          window.pageYOffset > 550 ||
          document.body.scrollTop > 550 ||
          document.documentElement.scrollTop > 550
        ) {
          if (st + 150 < documentHg) {
            document
              .querySelector('.scroll-to--to-top')
              .classList.add('is-visible');
          }
        } else {
          document
            .querySelector('.scroll-to--to-top')
            .classList.remove('is-visible');
        }
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }
    scrollFunction();
  }
};
